import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { SsoService } from './sso.service';

/**
 * Guard permettant de conditionner le guard de SSO Azure selon le paramètrage sso de l'application
 */
export const conditionalSsoAzureGuard: CanActivateFn = (_route, _state) => {
	const msalGuard: MsalGuard = inject(MsalGuard);
	const ssoService: SsoService = inject(SsoService);

	if (!ssoService.ssoActif()) {
		return true;
	}

	return msalGuard.canActivate(_route, _state);

};
